import request from "@/utils/request";

// 登录方法
// export function login(data) {
//   return request({
//     url: `/sys/user/login`,
//     headers: {
//       isToken: false,
//     },
//     method: "post",
//     data,
//   });
// }

// 注册方法
export function register(data) {
  return request({
    url: "/register",
    method: "post",
    data: data,
  });
}

// 获取验证码
export function getVerifyCode() {
  return request({
    url: "/common/yzm",
    method: "get",
  });
}

// 登录，获取token接口
export function login(data) {
  return request({
    url: "/chzz-user/authentication",
    method: "post",
    data,
  });
}
// 普通KEY登录，获取token接口
export function keyLogin(data) {
  return request({
    url: "/login/key",
    method: "post",
    data,
  });
}
// 万能key二次登录
export function wanNengKeyLogin(data) {
  return request({
    url: "/account-service/universal-key/login",
    method: "post",
    data,
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: "/chzz-user/userinfo",
    method: "get",
  });
}

// 重置密码
export function resetPwd(data) {
  return request({
    url: `/account-service/universal-key/password/reset`,
    method: "post",
    data,
  });
}

// 账号解锁
export function unlockUser(data) {
  return request({
    url: `/account-service/universal-key/unlock`,
    method: "post",
    data,
  });
}

// 退出方法
export function logout() {
  return request({
    url: "/logout/tcdl",
    method: "post",
    data: {
      userType: "",
    },
  });
}

// 修改密码
export function modifyPwd(data) {
  return request({
    url: "/account-service/user/password/modify",
    method: "post",
    data,
  });
}

// 万能key用户登录
export function wNengKLogin(data) {
  return request({
    url: "/chzz-user/universal-key/login",
    method: "post",
    data,
  });
}
